import { render, staticRenderFns } from "./s-text-info.vue?vue&type=template&id=246175f2&scoped=true"
import script from "./s-text-info.vue?vue&type=script&lang=js"
export * from "./s-text-info.vue?vue&type=script&lang=js"
import style0 from "./s-text-info.vue?vue&type=style&index=0&id=246175f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246175f2",
  null
  
)

export default component.exports